module.exports = __webpack_public_path__ + "static/media/nosound.3b6e0a37.mp3";